module.exports = __webpack_public_path__ + "img/day03.c6e5672b.png";